export enum LocalStorageKeys {
  HTTP_CLIENT_RESIZABLE_WIDTH = 'HTTP_CLIENT_RESIZABLE_WIDTH',
  HTML_EDITOR_RESIZABLE_WIDTH = 'HTML_EDITOR_RESIZABLE_WIDTH',
  HTML_EDITOR_RESIZABLE_VARIABLES_HEIGHT = 'HTML_EDITOR_RESIZABLE_VARIABLES_HEIGHT',
  PDF_EDITOR_RESIZABLE_WIDTH = 'PDF_EDITOR_RESIZABLE_WIDTH',
  SMS_EDITOR_RESIZABLE_WIDTH = 'SMS_EDITOR_RESIZABLE_WIDTH',
  WHATSAPP_EDITOR_RESIZABLE_WIDTH = 'WHATSAPP_EDITOR_RESIZABLE_WIDTH',
  WHATSAPP_PREVIEW_OPTIONS = 'WHATSAPP_PREVIEW_OPTIONS',
  UNPUBLISHED_WORKFLOWS = 'UNPUBLISHED_WORKFLOWS',
  APP_THEME = 'APP_THEME',
}
